import styled, { css } from 'styled-components'

export const Container = styled.div<{ active: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  visibility: hidden;

  ${({ active }) =>
    active &&
    css`
      z-index: 1;
      visibility: visible;
    `}
`

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
`
